import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { getSpacing, typography } from 'stylesheet';

export const NotFoundPageContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
`;

export const NotFoundTextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  text-align: center;
`;

export const NotFoundImage = styled.img`
  width: 215px;
  height: 161px;
`;

export const Title = styled.h1`
  ${typography.title_small};
  margin-bottom: ${getSpacing(3)};
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
`;
